module.exports = __webpack_public_path__ + "fonts/fb969c3d39b6520c677d7f4dddb79d34.svg";